import { Checkbox, Select } from 'antd';
import FormItem from 'app/components/Form/FormItem';
import Input from 'app/components/Input';
import Radio from 'app/components/RadioButton';
import { FIELD_TYPES } from 'app/types';
import React from 'react';
import CheckList from './CheckList';
import CommonTemplates from './CommonTemplates';
import DefectList from './DefectList';
import { StyledFormItem } from './StyledItem';
import { Uploader } from './Uploader';

export const renderInput = (
  config: Partial<{
    inputProps: any;
    type: string;
    name: string;
    label: string;
    [x: string]: any;
  }>,
  rootName: any[],
  key: string,
  formItemProps?: any
) => {
  const { type, label, name = '', inputProps, readonly } = config;
  switch (type) {
    case FIELD_TYPES.INPUT:
      return (
        <StyledFormItem key={key} name={[...rootName, name]} {...formItemProps}>
          <Input disabled={readonly} {...inputProps}></Input>
        </StyledFormItem>
      );
    case FIELD_TYPES.TEXTAREA:
      return (
        <FormItem key={key} name={[...rootName, name]}>
          <Input.TextArea disabled={readonly} {...inputProps}></Input.TextArea>
        </FormItem>
      );
    case FIELD_TYPES.CHECKBOX:
      return (
        <StyledFormItem
          key={key}
          name={[...rootName, name]}
          valuePropName={config.options ? 'value' : 'checked'}
          {...formItemProps}
        >
          {config?.options ? (
            <Checkbox.Group
              disabled={readonly}
              options={config.options}
              {...inputProps}
            ></Checkbox.Group>
          ) : (
            <Checkbox disabled={readonly}>{label}</Checkbox>
          )}
        </StyledFormItem>
      );
    case FIELD_TYPES.RADIO:
      return (
        <StyledFormItem
          key={key}
          name={[...rootName, name]}
          valuePropName={config.options ? 'value' : 'checked'}
          {...formItemProps}
        >
          {config?.options ? (
            <Radio.Group
              disabled={readonly}
              options={config.options}
            ></Radio.Group>
          ) : (
            <Radio disabled={readonly}>{label}</Radio>
          )}
        </StyledFormItem>
      );
    case FIELD_TYPES.SELECT:
      return (
        <StyledFormItem key={key} name={[...rootName, name]} {...formItemProps}>
          <Select disabled={readonly} {...inputProps} options={config.options}>
            {label}
          </Select>
        </StyledFormItem>
      );

    case FIELD_TYPES.DEFECTS:
      return (
        <StyledFormItem style={{ paddingLeft: 0 }} shouldUpdate>
          {(form) => {
            return (
              <DefectList
                form={form}
                key={key}
                name={[...rootName, name]}
                config={config}
                readonly={readonly}
              ></DefectList>
            );
          }}
        </StyledFormItem>
      );
    case FIELD_TYPES.CHECKLIST:
      return (
        <StyledFormItem shouldUpdate>
          {(form) => {
            return (
              <CheckList
                form={form}
                key={key}
                name={[...rootName, name]}
                config={config}
                readonly={readonly}
              ></CheckList>
            );
          }}
        </StyledFormItem>
      );
    case FIELD_TYPES.SECTION:
      return (
        <FormItem shouldUpdate>
          {() => {
            return (
              <CommonTemplates
                fields={config?.field?.fields}
                rootName={[...rootName, name]}
                sectionName={config?.field.name}
                key={key}
                configs={config?.configs}
                readonly={readonly}
              ></CommonTemplates>
            );
          }}
        </FormItem>
      );
    case FIELD_TYPES.UPLOAD:
      return (
        <StyledFormItem key={key} name={[...rootName, name]}>
          <Uploader disabled={readonly} {...inputProps}></Uploader>
        </StyledFormItem>
      );
  }
};
